export const customOnAutocompleteChange = ({
  e,
  value,
  customAction,
  setInForm,
  validateField,
}) => {
  const target = e.currentTarget.querySelector('[data-fieldname]') || e.currentTarget;

  if (target) {
    const { fieldname } = target.dataset;
    const { name } = target;
    const { fieldName, fieldValue } = { fieldName: fieldname || name, fieldValue: value || '' };

    customAction?.({ fieldName, fieldValue });
    setInForm(fieldName, fieldValue);

    if (validateField) {
      setTimeout(() => validateField(fieldName, fieldValue));
    }
  }
};

export const getPlaceholder = (condition, placeholder, fallback = '-') =>
  condition ? placeholder : fallback;

export const mapFieldsToFalse = fields =>
  fields.reduce((acc, fieldName) => {
    acc[fieldName] = false;

    return acc;
  }, {});
